export default __webpack_public_path__ + "static/media/editorIcon.3c5a1eb1.png";